import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["introducerField"];
  static values = { friendReferralId: Number };

  change(e) {
    const showIntroducer =
      e.target.value === String(this.friendReferralIdValue);
    this.introducerFieldTarget.style.display = showIntroducer ? "" : "none";

    if (!showIntroducer) {
      const input = this.introducerFieldTarget.querySelector("input");
      if (input) input.value = "";
    }
  }
}
